import React from 'react'
import clsx from 'clsx'
import { Paper, useTheme } from '@mui/material'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'
import LayoutMain from '../layouts/Main'
import LayoutBase from '../layouts/Base'
import Text from '../components/Text'
import Logo from '../components/Logo'
// Os links daqui precisam preservar api e secret da URL: quem entra pelo painel
// do revendedor não tem as credenciais no navegador, e um Link puro derrubaria
// a sessão ao trocar de página.
import Link from '../components/LinkWithQuery'
import metaPrimary from '../assets/meta-primary-color.png'
import metaWhite from '../assets/meta-white-color.png'

export default function ChangelogPage() {
  const theme = useTheme()

  return (
    <LayoutBase>
      <LayoutMain>
        <div className="relative w-full py-14">
          <div
            className={clsx('absolute top-0 left-0 w-full h-[400px] ', {
              'bg-opacity-[0.05] bg-white': theme.isDark,
              'bg-opacity-[0.05] bg-gray-500': !theme.isDark
            })}
          />
          <div
            className={clsx('absolute top-0 left-0 w-full h-[550px]', {
              'bg-opacity-[0.05] bg-white': theme.isDark,
              'bg-opacity-[0.05] bg-gray-500': !theme.isDark
            })}
          />
          <div className="relative py-12 md:py-32">
            <div className="mx-auto w-full md:max-w-[950px] px-2 md:px-12">
              <Text className="text-2xl mb-6">Changelog</Text>
              <div className="space-y-12">
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        Disparo em massa com custo e saldo conferidos
                      </Text>
                      <Text className="mb-1">
                        v3.7.0
                      </Text>
                      <TagFeature />
                    </div>
                    <div className="mt-8 space-y-4">
                      <Text>
                        A página <Text className="inline font-black" component="span">Enviar mensagem</Text> virou um disparo para uma lista de clientes. Antes ela mandava número por número direto do navegador, sem dizer quanto ia custar nem se havia saldo — e na API Oficial não dava para usar um modelo aprovado. Agora o disparo é montado em três passos e roda no servidor: pode fechar o navegador que ele continua.
                      </Text>
                      <Text className="font-black text-lg mt-6">O que mudou:</Text>
                      <ul className="space-y-2 ml-4">
                        <li><Text>Importe uma planilha CSV ou cole os números; repetidos saem sozinhos e os inválidos aparecem marcados</Text></li>
                        <li><Text>Na API Oficial você escolhe um modelo aprovado e diz de qual coluna da planilha vem cada campo, vendo como a mensagem chega no WhatsApp do cliente</Text></li>
                        <li><Text>Antes de disparar, um resumo mostra o custo máximo pela sua faixa da régua e um medidor do saldo: o que você tem, o que este disparo leva e o que sobra</Text></li>
                        <li><Text>Se o saldo não cobre, você escolhe entre recarregar ou disparar só para os que cabem agora</Text></li>
                        <li><Text>Dá para mandar um teste para o seu próprio número antes de disparar para todos</Text></li>
                        <li><Text>A aba <Text className="inline font-black" component="span">Acompanhar</Text> mostra o andamento em tempo real e permite cancelar o que ainda não saiu</Text></li>
                        <li><Text>Se o saldo acabar no meio, o disparo pausa e volta sozinho depois da recarga</Text></li>
                      </ul>
                      <Text className="font-black text-lg mt-6">Também nesta versão:</Text>
                      <ul className="space-y-2 ml-4">
                        <li><Text>Mensagens canceladas aparecem nos relatórios como <Text className="inline font-black" component="span">Cancelada pelo cliente</Text> — não saíram e não foram cobradas</Text></li>
                        <li><Text>O histórico dos agendamentos passou a dizer quantas mensagens ficaram retidas por falta de saldo</Text></li>
                      </ul>
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        Menu no topo e nova marca
                      </Text>
                      <Text className="mb-1">
                        v3.6.0
                      </Text>
                      <TagFeature />
                    </div>
                    <div className="mt-8">
                      <div className="flex justify-center">
                        <Logo tamanho="grande" assinatura />
                      </div>
                    </div>
                    <div className="mt-8 space-y-4">
                      <Text>
                        O menu saiu da lateral e subiu para o <Text className="inline font-black" component="span">topo da tela</Text>. Ele ficava escondido atrás do botão de três linhas em qualquer monitor mais estreito — inclusive em notebook comum — e muita gente simplesmente não encontrava as páginas. Agora ele está sempre à vista.
                      </Text>
                      <Text className="font-black text-lg mt-6">O que mudou:</Text>
                      <ul className="space-y-2 ml-4">
                        <li><Text>As páginas do dia a dia viraram abas fixas no topo, visíveis em qualquer tamanho de tela</Text></li>
                        <li><Text>No celular, a navegação virou uma barra fixa embaixo, ao alcance do polegar</Text></li>
                        <li><Text>A página em que você está agora fica marcada — antes nada indicava onde você estava</Text></li>
                        <li><Text>Sua API, o secret e o servidor saíram do meio do menu e passaram para o indicador de conexão, no canto direito do topo, com botão de copiar</Text></li>
                        <li><Text>A tela inicial ganhou atalhos com explicação do que cada página faz</Text></li>
                        <li><Text>Nomes mais diretos: "Expediente de envios" virou <Text className="inline font-black" component="span">Horários de envio</Text>, "SmartFilter" virou <Text className="inline font-black" component="span">Filtro de números</Text> e "Changelog" virou <Text className="inline font-black" component="span">Novidades da versão</Text></Text></li>
                      </ul>
                      <Text className="font-black text-lg mt-6">Nome novo:</Text>
                      <Text>
                        O produto passa a se chamar <Text className="inline font-black" component="span">GLA HiperWaba</Text>. Nada muda na sua integração: a API, o secret, os endereços e todos os endpoints continuam exatamente os mesmos.
                      </Text>
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        Cobrança mais transparente
                      </Text>
                      <Text className="mb-1">
                        v3.5.0
                      </Text>
                      <TagImprovement />
                    </div>
                    <div className="mt-8">
                      <div className="flex items-center justify-center space-x-5">
                        <Logo tamanho="grande" />
                        <span className="font-black text-4xl">+</span>
                        <div className="px-3 py-1 bg-sky-600">
                          <span className="font-black text-2xl text-white">Consumo</span>
                        </div>
                      </div>
                    </div>
                    <div className="mt-8 space-y-4">
                      <Text>
                        Ficou mais fácil entender <Text className="inline font-black" component="span">quanto você gasta e por quê</Text> nas conexões Meta Oficial, onde o preço varia conforme a categoria da mensagem.
                      </Text>
                      <Text className="font-black text-lg mt-6">O que mudou:</Text>
                      <ul className="space-y-2 ml-4">
                        <li><Text>As estimativas passaram a usar o preço real da categoria de utilidade, em vez de um valor médio</Text></li>
                        <li><Text>Acompanhamento de consumo com os rótulos de categoria que a Meta usa na cobrança</Text></li>
                        <li><Text>Modelos prontos de banner no gerenciador da página de pagamento, para não começar do zero</Text></li>
                        <li><Text>O corpo da mensagem já aparece no momento de criar o modelo, uma tag por linha</Text></li>
                        <li><Text>Provedor sem arquivo de logo pode escrever o nome, que vira a marca da página de pagamento</Text></li>
                      </ul>
                      <Text>
                        Veja em <Link className="font-black" to="/reports">Relatórios</Link> e em <Link className="font-black" to="/hiperpay/profiles">Cobranças</Link>.
                      </Text>
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        Agendamento de mensagens
                      </Text>
                      <Text className="mb-1">
                        v3.4.0
                      </Text>
                      <TagFeature />
                    </div>
                    <div className="mt-8">
                      <div className="flex items-center justify-center space-x-5">
                        <Logo tamanho="grande" />
                        <span className="font-black text-4xl">+</span>
                        <div className="px-3 py-1 bg-emerald-600">
                          <span className="font-black text-2xl text-white">Agendamentos</span>
                        </div>
                      </div>
                    </div>
                    <div className="mt-8 space-y-4">
                      <Text>
                        Agora dá para <Text className="inline font-black" component="span">programar mensagens</Text> direto no painel, sem depender de um sistema seu chamando a API na hora certa.
                      </Text>
                      <Text className="font-black text-lg mt-6">Novidades:</Text>
                      <ul className="space-y-2 ml-4">
                        <li><Text>Envio único em data e hora marcadas, ou repetição diária, semanal e mensal</Text></li>
                        <li><Text>Lista de destinatários visível e editável, com o nome de cada pessoa</Text></li>
                        <li><Text>Personalização por destinatário: {'{{nome}}'} é trocado pelo nome de quem recebe</Text></li>
                        <li><Text>Em conexão Meta Oficial, o agendamento usa um modelo já aprovado — como a Meta exige</Text></li>
                        <li><Text>Botão de enviar um teste antes de agendar de verdade</Text></li>
                        <li><Text>Histórico de cada disparo, com o que saiu e o que falhou</Text></li>
                      </ul>
                      <Text>
                        Comece em <Link className="font-black" to="/messages/scheduled">Agendamentos</Link>.
                      </Text>
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        Conexão com a Meta em um clique
                      </Text>
                      <Text className="mb-1">
                        v3.3.0
                      </Text>
                      <TagFeature />
                    </div>
                    <div className="mt-8">
                      <div className="flex items-center justify-center space-x-5">
                        <Logo tamanho="grande" />
                        <span className="font-black text-4xl">+</span>
                        <div>
                          <img
                            src={window.localStorage.getItem('preferredTheme') === 'dark' ? metaWhite : metaPrimary}
                            className="w-[150px]"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-8 space-y-4">
                      <Text>
                        Conectar um número à <Text className="inline font-black" component="span">API Oficial</Text> deixou de exigir copiar tokens e IDs entre o Facebook e o painel. Agora é um botão: você entra com a sua conta do Facebook, escolhe o número e pronto.
                      </Text>
                      <Text className="font-black text-lg mt-6">Novidades:</Text>
                      <ul className="space-y-2 ml-4">
                        <li><Text>Login com Facebook direto na tela de conexão, sem token na mão</Text></li>
                        <li><Text>Mensagens de erro que explicam o que aconteceu quando a conexão não fecha</Text></li>
                        <li><Text>Modelos que pertencem a outra conta agora ficam identificados, e dá para recriá-los na sua</Text></li>
                      </ul>
                      <Text className="font-black text-lg mt-6">Nos relatórios:</Text>
                      <ul className="space-y-2 ml-4">
                        <li><Text>Reenviar mensagem com erro passou a dizer o motivo da falha, em português</Text></li>
                        <li><Text>Mensagem que chegou ao destinatário aparece como <Text className="inline font-black" component="span">entregue</Text> — antes algumas apareciam como erro mesmo tendo chegado</Text></li>
                        <li><Text>Números e ações cabem na primeira tela, sem rolar</Text></li>
                        <li><Text>O endereço completo da página de pagamento fica visível para copiar</Text></li>
                      </ul>
                      <Text>
                        Conecte em <Link className="font-black" to="/">Início</Link> ou confira em <Link className="font-black" to="/reports">Relatórios</Link>.
                      </Text>
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        Painel Meta Oficial mais claro
                      </Text>
                      <Text className="mb-1">
                        v3.2.0
                      </Text>
                      <TagImprovement />
                    </div>
                    <div className="mt-8">
                      <div className="flex items-center justify-center space-x-5">
                        <Logo tamanho="grande" />
                        <span className="font-black text-4xl">+</span>
                        <div>
                          <img
                            src={window.localStorage.getItem('preferredTheme') === 'dark' ? metaWhite : metaPrimary}
                            className="w-[150px]"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-8 space-y-4">
                      <Text>
                        Reorganizamos o painel da sua conta <Text className="inline font-black" component="span">Meta Oficial</Text> para deixar a leitura mais rápida e a hierarquia das informações mais clara.
                      </Text>
                      <Text className="font-black text-lg mt-6">O que mudou:</Text>
                      <ul className="space-y-2 ml-4">
                        <li><Text>Avisos de pendência agora aparecem no topo do painel, em destaque — antes ficavam lá no rodapé</Text></li>
                        <li><Text>O status da conexão com a Meta ficou mais compacto e posicionado junto dos dados da conta</Text></li>
                        <li><Text>Informações reorganizadas por prioridade: primeiro os dados da conta, depois as ações recomendadas</Text></li>
                        <li><Text>A versão do painel agora fica visível no próprio diagrama de conexão</Text></li>
                      </ul>
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        SmartFilter — Filtro inteligente anti-desperdício
                      </Text>
                      <Text className="mb-1">
                        v3.1.0
                      </Text>
                      <TagFeature />
                    </div>
                    <div className="mt-8">
                      <div className="flex items-center justify-center space-x-5">
                        <Logo tamanho="grande" />
                        <span className="font-black text-4xl">+</span>
                        <div className="px-3 py-1 bg-emerald-600">
                          <span className="font-black text-2xl text-white">SmartFilter</span>
                        </div>
                      </div>
                    </div>
                    <div className="mt-8 space-y-4">
                      <Text>
                        Estreia o <Text className="inline font-black" component="span">SmartFilter</Text>: uma camada que analisa cada mensagem antes do envio e decide se <Text className="inline font-black" component="span">envia, bloqueia, atrasa ou segura para aprovação</Text> — cortando custo com a Meta e protegendo o número do provedor.
                      </Text>
                      <Text className="font-black text-lg mt-6">Novidades:</Text>
                      <ul className="space-y-2 ml-4">
                        <li><Text>Receitas de 1 clique: não repetir mensagem, máximo por dia, intervalo mínimo e lista de não-perturbe</Text></li>
                        <li><Text>Cobrança inteligente: só faturas vencidas, não cobrar cedo demais, valor mínimo e cobrança alta para aprovação</Text></li>
                        <li><Text>Bloqueio de variável não preenchida (#areceber_data_vencimento#, %copiaecola%, {'{codigopix}'})</Text></li>
                        <li><Text>Teto de envios: trava o gasto máximo por mês ou período de datas</Text></li>
                        <li><Text>Modos seguros (Observação, Simulação e Ativo) com lista-negra ou lista-branca</Text></li>
                        <li><Text>Fila de aprovação, lista de bloqueio com importação em massa e painel de decisões com economia estimada</Text></li>
                        <li><Text>À prova de falhas: em caso de erro, a mensagem é sempre enviada</Text></li>
                      </ul>
                      <Text>
                        Comece em <Link className="font-black" to="/smart-filter">SmartFilter</Link> ou leia o guia completo em <Link className="font-black" to="/documentation#smart-filter">Documentação → SmartFilter</Link>.
                      </Text>
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        Oficial — Painel Meta + Novo Layout
                      </Text>
                      <Text className="mb-1">
                        v3.0.0
                      </Text>
                      <TagFeature />
                    </div>
                    <div className="mt-8">
                      <div className="flex items-center justify-center space-x-5">
                        <Logo tamanho="grande" />
                        <span className="font-black text-4xl">+</span>
                        <div>
                          <img
                            src={window.localStorage.getItem('preferredTheme') === 'dark' ? metaWhite : metaPrimary}
                            className="w-[150px]"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-8 space-y-4">
                      <Text>
                        Marco importante da plataforma: agora o painel mostra <Text className="inline font-black" component="span">dados oficiais da sua conta Meta</Text> em tempo real e estreia um <Text className="inline font-black" component="span">novo layout (Preview)</Text> que pode ser ativado pelas Configurações.
                      </Text>
                      <Text className="font-black text-lg mt-6">Novidades:</Text>
                      <ul className="space-y-2 ml-4">
                        <li><Text>Painel completo da conta Meta Oficial: número, nome verificado, qualidade, limite de mensagens, verificação do negócio, PIN de segurança e perfil business</Text></li>
                        <li><Text>Saúde da conta: pontuação consolidada com fatores ponderados e recomendações contextuais de próximos passos</Text></li>
                        <li><Text>Modelos de mensagem com pré-visualização estilo WhatsApp (cabeçalho, corpo, rodapé, botões e variáveis)</Text></li>
                        <li><Text>Banner promocional configurável via banco para conversão QR Code → API Oficial, com variantes soft/highlight/urgent e countdown</Text></li>
                        <li><Text>Card de upgrade whitelabel para clientes sem permissão de API Oficial no plano, com contato do revendedor configurável</Text></li>
                        <li><Text>Bloqueio inteligente da API Oficial por funcionalidade do plano sem expor campos sensíveis (Number ID, Business ID, Token)</Text></li>
                        <li><Text>Novo layout Preview "Conversacional WhatsApp" com sidebar redesenhada, cabeçalho dinâmico de boas-vindas e identidade visual mais próxima de produtos modernos</Text></li>
                        <li><Text>Sincronização correta do número exibido na sidebar com o display oficial da Meta</Text></li>
                      </ul>
                      <Text>
                        Para experimentar o novo layout, acesse <Link className="font-black" to="/settings">Configurações</Link> e selecione "Novo layout" no bloco de Tema.
                      </Text>
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        Painel mais fácil de usar
                      </Text>
                      <Text className="mb-1">
                        v2.5.0
                      </Text>
                      <TagImprovement />
                    </div>
                    <div className="mt-8">
                      <div className="flex justify-center">
                        <Logo tamanho="grande" />
                      </div>
                    </div>
                    <div className="mt-8 space-y-4">
                      <Text>
                        Uma leva de melhorias no uso do dia a dia, boa parte vinda de reclamação de quem estava no suporte. O painel passou a funcionar em tela pequena e a explicar melhor o que estava acontecendo.
                      </Text>
                      <Text className="font-black text-lg mt-6">O que mudou:</Text>
                      <ul className="space-y-2 ml-4">
                        <li><Text>Escolha entre tema claro e escuro, guardada no seu navegador</Text></li>
                        <li><Text>Menu passou a funcionar em telas pequenas, no celular e dentro de iframe — antes ele simplesmente não abria nesses casos</Text></li>
                        <li><Text>Dá para entrar pelo endereço, com a api e o secret na própria URL, e a sessão salva é retomada sozinha</Text></li>
                        <li><Text>QR Code se renova sozinho a cada 30 segundos e diz o que está acontecendo enquanto carrega</Text></li>
                        <li><Text>Fim dos pedidos repetidos de QR Code, que às vezes geravam dois códigos ao mesmo tempo</Text></li>
                        <li><Text>Confirmação de entrega e leitura corrigida: mensagem que só chegou ao servidor deixou de aparecer como entregue ao destinatário</Text></li>
                        <li><Text>Botão de recarregar e aviso visual quando a mensagem carrega arquivo</Text></li>
                        <li><Text>Escolha entre as versões de conexão disponíveis para o número</Text></li>
                      </ul>
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        HiperPay Profiles + Gerador de Templates
                      </Text>
                      <Text className="mb-1">
                        v2.4.0
                      </Text>
                      <TagFeature />
                    </div>
                    <div className="mt-8">
                      <div className="flex items-center justify-center space-x-5">
                        <Logo tamanho="grande" />
                        <span className="font-black text-4xl">+</span>
                        <div>
                          <img
                            src={`/assets/images/${window.localStorage.getItem('preferredTheme') === 'dark' ? 'hiperpay-logo-primary-text-white.png' : 'hiperpay-logo-primary.png'}`}
                            className="w-[180px]"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-8 space-y-4">
                      <Text>
                        Agora e possivel configurar o <Text className="inline font-black" component="span">branding das paginas de pagamento do HiperPay</Text> diretamente pelo painel, sem depender do ERP. Cada instancia pode ter sua propria integracao isolada com profiles de logo, cores, titulos e rodape.
                      </Text>
                      <Text className="font-black text-lg mt-6">Novidades:</Text>
                      <ul className="space-y-2 ml-4">
                        <li><Text>Ativacao do HiperPay com um clique, sem configuracao manual</Text></li>
                        <li><Text>Profiles de branding por instancia (logo, cor primaria, titulos, rodape, mensagem informativa)</Text></li>
                        <li><Text>Modo compacto com <Text className="inline-block font-black text-white bg-gray-600 px-1" component="span">%ProfileId%</Text> para ERPs com limite de caracteres</Text></li>
                        <li><Text>Gerador de templates pronto para IXC, MK-AUTH e SGP</Text></li>
                        <li><Text>Compativel com QR Code (Baileys) e Meta API Oficial (Evolution)</Text></li>
                        <li><Text>Preview visual de como a mensagem chega ao cliente</Text></li>
                        <li><Text>Botao de copiar ID do profile para uso no template do ERP</Text></li>
                      </ul>
                      <Text>
                        Para configurar, acesse a pagina <Link className="font-black" to="/hiperpay/profiles">HiperPay Profiles</Link> no menu.
                      </Text>
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        Whatsapp API Oficial
                      </Text>
                      <Text className="mb-1">
                        Mensagens simples e com botôes
                      </Text>
                      <TagFeature />
                    </div>
                    <div className="mt-8">
                      <div className="flex items-center justify-center space-x-5">
                        <Logo tamanho="grande" />
                        <span className="font-black text-4xl">+</span>
                        <div>
                          <img
                            src={window.localStorage.getItem('preferredTheme') === 'dark' ? metaWhite : metaPrimary}
                            className="w-[150px]"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-8">
                      <Text>
                        Adicionado nova tag <Text className="inline-block font-black text-white bg-gray-600 px-1" component="span">%WhatsappCloudApi%</Text>, onde será possível enviar mensagens simples e mensagens com botões através dos templates da Whatsapp API Oficial da Meta.
                      </Text>
                      <div className="my-6 flex items-center justify-center space-x-4">
                        <img src="/assets/images/hipersend-doc-6.png" className="w-full" />
                      </div>
                      <Text>
                        Para mais detalhes sobre a implementação das mensagens com a api oficial, acesse a página da documentação em <Link className="font-black" to="/documentation#message-cloud-official">Mensagem API Oficial</Link> ou converse com um de nossos especialistas para realizar um upgrade na sua integração.
                      </Text>
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        Linha digitável do boleto
                      </Text>
                      <TagFeature />
                    </div>
                    <div className="mt-8">
                      <div className="flex items-center justify-center space-x-5">
                        <Logo tamanho="grande" />
                        <span className="font-black text-4xl">+</span>
                        <div>
                          <img
                            src={`/assets/images/${window.localStorage.getItem('preferredTheme') === 'dark' ? 'hiperpay-logo-primary-text-white.png' : 'hiperpay-logo-primary.png'}`}
                            className="w-[180px]"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-8">
                      <Text>
                        Adicionado nova tag <Text className="inline-block font-black text-white bg-gray-600 px-1" component="span">%BankSlip%</Text>, onde será possível enviar a linha digitável do boleto para facilitar a ação de copia e cola no link de pagamento.
                      </Text>
                      <div className="my-6 flex items-center justify-center space-x-4">
                        <img src="/assets/images/hipersend-doc-5.png" className="w-full" />
                      </div>
                      <Text>
                        Para mais detalhes sobre a implementação da mensagem pix, acesse a página da nova documentação em <Link className="font-black" to="/documentation#message-pix">Mensagem Pix.</Link>
                      </Text>
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        Textos customizados do footer do link de pagamento
                      </Text>
                      <TagFeature />
                    </div>
                    <div className="mt-8">
                      <div className="flex items-center justify-center space-x-5">
                        <Logo tamanho="grande" />
                        <span className="font-black text-4xl">+</span>
                        <div>
                          <img
                            src={`/assets/images/${window.localStorage.getItem('preferredTheme') === 'dark' ? 'hiperpay-logo-primary-text-white.png' : 'hiperpay-logo-primary.png'}`}
                            className="w-[180px]"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-8">
                      <Text>
                        Agora é possível customizar os textos do footer da página do link de pagamento. Duas novas tags foram adicionadas, <Text className="inline-block font-black text-white bg-gray-600 px-1" component="span">%FooterTitle%</Text> e <Text className="inline-block font-black text-white bg-gray-600 px-1" component="span">%FooterSubtitle%</Text> estão disponíveis para uso na nova atualização.
                      </Text>
                      <div className="my-6 flex items-center justify-center space-x-4">
                        <img src="/assets/images/hipersend-doc-4.png" className="w-full" />
                      </div>
                      <Text>
                        Para mais detalhes sobre a implementação da mensagem pix, acesse a página da nova documentação em <Link className="font-black" to="/documentation#message-pix">Mensagem Pix.</Link>
                      </Text>
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        Novas tags semânticas para link de pagamento HiperPay
                      </Text>
                      <TagFeature />
                    </div>
                    <div className="mt-8">
                      <div className="flex items-center justify-center space-x-5">
                        <Logo tamanho="grande" />
                        <span className="font-black text-4xl">+</span>
                        <div>
                          <img
                            src={`/assets/images/${window.localStorage.getItem('preferredTheme') === 'dark' ? 'hiperpay-logo-primary-text-white.png' : 'hiperpay-logo-primary.png'}`}
                            className="w-[180px]"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-8">
                      <Text>
                        Novas tags foram adicionadas para garantir a semântica dos templates de mensagens envolvendo os links de pagamento hiperpay, com isso algumas tags foram marcadas como deprecated, mas que continuaram funcionando até sua remoção completa.
                      </Text>
                      <div className="mt-4 flex items-center space-x-2">
                        <Text className="font-black text-xl">
                          Tags deprecated
                        </Text>
                        <ArrowRightAltIcon />
                        <Text className="font-black text-xl">
                          Tags novas
                        </Text>
                      </div>
                      <ul className="mb-4 mt-1">
                        <li>
                          <div className="flex space-x-2 items-center">
                            <Text className="font-black">
                              %PixTitle%
                            </Text>
                            <ArrowRightAltIcon />
                            <Text className="font-black">
                              %Title%
                            </Text>
                          </div>
                        </li>
                        <li>
                          <div className="flex space-x-2 items-center">
                            <Text className="font-black">
                              %PixSubtitle%
                            </Text>
                            <ArrowRightAltIcon />
                            <Text className="font-black">
                              %Subtitle%
                            </Text>
                          </div>
                        </li>
                        <li>
                          <div className="flex space-x-2 items-center">
                            <Text className="font-black">
                              %PixPrice%
                            </Text>
                            <ArrowRightAltIcon />
                            <Text className="font-black">
                              %Price%
                            </Text>
                          </div>
                        </li>
                        <li>
                          <div className="flex space-x-2 items-center">
                            <Text className="font-black">
                              %PixLogoUrl%
                            </Text>
                            <ArrowRightAltIcon />
                            <Text className="font-black">
                              %LogoUrl%
                            </Text>
                          </div>
                        </li>
                        <li>
                          <div className="flex space-x-2 items-center">
                            <Text className="font-black">
                              %PixInvoiceUrl%
                            </Text>
                            <ArrowRightAltIcon />
                            <Text className="font-black">
                              %InvoiceUrl%
                            </Text>
                          </div>
                        </li>
                        <li>
                          <div className="flex space-x-2 items-center">
                            <Text className="font-black">
                              %PixInfo%
                            </Text>
                            <ArrowRightAltIcon />
                            <Text className="font-black">
                              %Info%
                            </Text>
                          </div>
                        </li>
                        <li>
                          <div className="flex space-x-2 items-center">
                            <Text className="font-black">
                              %PixPrimaryColor%
                            </Text>
                            <ArrowRightAltIcon />
                            <Text className="font-black">
                              %PrimaryColor%
                            </Text>
                          </div>
                        </li>
                        <li>
                          <div className="flex space-x-2 items-center">
                            <Text className="font-black">
                              %PixThumbnail%
                            </Text>
                            <ArrowRightAltIcon />
                            <Text className="font-black">
                              %Thumbnail%
                            </Text>
                          </div>
                        </li>
                      </ul>
                      <Text>
                        Para mais detalhes sobre a implementação da mensagem pix, acesse a página da nova documentação em <Link className="font-black" to="/documentation#message-pix">Mensagem Pix.</Link>
                      </Text>
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        Mensagem PIX
                      </Text>
                      <TagFeature />
                    </div>
                    <div className="mt-8">
                      <div className="flex items-center justify-center space-x-5">
                        <Logo tamanho="grande" />
                        <span className="font-black text-4xl">+</span>
                        <div>
                          <img
                            src={`/assets/images/${window.localStorage.getItem('preferredTheme') === 'dark' ? 'hiperpay-logo-primary-text-white.png' : 'hiperpay-logo-primary.png'}`}
                            className="w-[180px]"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-8">
                      <Text>
                        Com a HiperPay liberamos a possibilidade dos contatos ter uma melhor experiência ao receber copia e cola, através de um link encurtado enviado ao contato onde ele irá abrir uma página facilitando o pagamento através de pix e outros meios de pagamento.
                      </Text>
                      <Text>
                        Para mais detalhes sobre a implementação da mensagem pix, acesse a página da nova documentação em <Link className="font-black" to="/documentation#message-pix">Mensagem Pix.</Link>
                      </Text>
                    </div>
                    <div>
                      <img src="/assets/images/hipersend-doc-3.png" className="w-full" />
                    </div>
                  </div>
                </Paper>
                <Paper elevation={3}>
                  <div className="p-6">
                    <div className="border-b border-[#6f6f6f4c] pb-6">
                      <Text className="font-black text-2xl">
                        Nova documentação detalhada da API
                      </Text>
                      <TagFeature />
                    </div>
                    <div className="mt-8">
                      <Text>
                        Agora é possível consultar a documentação detalhada da api, com diversos exemplos de como realizar a implementação em cenários diferentes.
                      </Text>
                      <div className="mb-8">
                        <img src="/assets/images/hipersend-doc.png" className="w-full" />
                      </div>
                      <Text>
                        Também é possível ter uma representação visual de como as mensagens podem ser implementadas em conjunto, pra formar um fluxo completo de acordo com diversas necessidades.
                      </Text>
                      <Text>
                        Para mais detalhes e informações, acesse a página da nova <Link className="font-black" to="/documentation">documentação.</Link>
                      </Text>
                      <div className="mb-8">
                        <img src="/assets/images/hipersend-doc-2.png" className="w-full" />
                      </div>
                    </div>
                  </div>
                </Paper>
              </div>
            </div>
          </div>
        </div>
      </LayoutMain>
    </LayoutBase>
  )
}

function TagFeature() {
  return (
    <div className="table bg-emerald-600 font-black text-white px-1">FEATURE</div>
  )
}

function TagImprovement() {
  return (
    <div className="table bg-sky-600 font-black text-white px-1">MELHORIA</div>
  )
}
